<template>
  <div v-once class="d-flex fd-column m-r-3">
    <span class="text-lg x-pulse PLACEHOLDER" />
    <span class="text-lg x-pulse PLACEHOLDER" />
    <span class="x-pulse PLACEHOLDER" />
  </div>
</template>

<script>
export default {
  name: 'job-list-item-placeholder',
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .PLACEHOLDER {
    @include rect(288px, 162px);
    margin: $unit/2 0;

    &:nth-child(2) {
      @include rect(270px, 19px);
    }
    &:nth-child(3) {
      @include rect(270px, 19px);
    }
  }
</style>
